import { SvgIcon, SvgIconProps } from "@mui/material";

const WorkbookIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
      <g id="SVGRepo_iconCarrier">
        <path
          d="M790.588 959.588h225.883V733.706H790.588v225.882Zm338.824 338.824h225.882v-225.883h-225.882v225.883Zm-338.824 0h225.883v-225.883H790.588v225.883Zm-338.823 0h225.882v-225.883H451.765v225.883Zm0-338.824h225.882V733.706H451.765v225.882Zm903.53-677.647v451.765h451.764v903.53H112.94V281.94h1242.353Zm112.94 23.379 315.445 315.445h-315.445V305.32Zm402.184 242.485L1541.195 218.58c-31.51-31.51-75.219-49.581-119.717-49.581H0v1581.176h1920V667.522c0-45.176-17.619-87.755-49.581-119.717Z"
          fillRule="evenodd"
        />
      </g>
    </SvgIcon>
  );
};

export default WorkbookIcon;
